import { css } from '@emotion/react';

export default $ => css`
  .collapsable-tree-select {
    > .dropdown-toggle {
      //max-width: 20em;

      > span {
        display: inline-block;
        width: 97%;
        text-overflow: ellipsis;
        overflow: hidden;
        line-height: 1em;
      }
    }

    > .dropdown-menu {
      max-height: 200px;
      overflow: auto;
    }
  }
`;
